import tokens from '@lacedltd/design-tokens'
import styled from '@emotion/styled'
import type { PasswordConditionStatus } from './PasswordCondition'

export const statusToColorMap: Record<PasswordConditionStatus, string> = {
  error: tokens.color.airPresto[800],
  unsatisfied: tokens.color.airJordan[600],
  satisfied: tokens.color.airJordan.p
}

export const Container = styled.div<{
  status: PasswordConditionStatus
}>(({ status }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: tokens.spacing[3],
  color: statusToColorMap[status]
}))

const ICON_SIZE = '1.5rem'

export const Icon = styled.div<{
  status: PasswordConditionStatus
  iconUrl: string
}>(({ status, iconUrl }) => ({
  backgroundColor: 'currentcolor',
  maskImage: `url(${iconUrl})`,
  maskSize: 'cover',
  flex: `0 0 ${ICON_SIZE}`,
  width: ICON_SIZE,
  height: ICON_SIZE,
  color: status === 'unsatisfied' ? tokens.color.airJordan[500] : undefined
}))

export const IconLabel = styled.p({
  margin: '0'
})
